
const digest = '19cca15365dd368da5c71002545cdad10af4fdd37560846226ff4c609e3686bd';
const classes = {"wrapper":"_wrapper_1lmae_1","checkbox":"_checkbox_1lmae_7","title":"_title_1lmae_13"};
const css = `._wrapper_1lmae_1 {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
}
._wrapper_1lmae_1 ._checkbox_1lmae_7 {
  min-width: 20px;
  min-height: 20px;
  max-width: 20px;
  max-height: 20px;
}
._wrapper_1lmae_1 ._title_1lmae_13 {
  font-size: 14px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  